
import { getIcon } from '~/utils/get-icon.js'

export default {
  props: {
    stats: {
      type: Array,
      default: () => [],
    },
    variant: {
      type: String,
      default: '',
      validator: (value) => ['', 'small'].includes(value.toLowerCase()),
    },
  },
  computed: {
    showStats() {
      return this.stats.length > 0
    },
  },
  methods: {
    iconComponent(iconName) {
      return getIcon(iconName)
    },
  },
}
